import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EmploymentStatus extends Enum {
  key!: string;
  value!: string;

  static EMPLOYED: EmploymentStatus = {
    key: 'employed',
    get value(): string {
      return Lang.t('contact.employed');
    }
  };

  static RETIRED: EmploymentStatus = {
    key: 'retired',
    get value(): string {
      return Lang.t('contact.retired');
    }
  };

  static UNEMPLOYED: EmploymentStatus = {
    key: 'unemployed',
    get value(): string {
      return Lang.t('contact.unemployed');
    }
  };

  static SELF_EMPLOYED: EmploymentStatus = {
    key: 'self_employed',
    get value(): string {
      return Lang.t('contact.self');
    }
  };

  static isEmploymentDetailsRequired(employmentStatus: string): boolean {
    return [EmploymentStatus.EMPLOYED.key, EmploymentStatus.SELF_EMPLOYED.key].includes(
      employmentStatus
    );
  }
}
